export const getNextValue = (value, stepper, fnConstraint) => {
  const nextValue = Number(value) + stepper;
  return fnConstraint(nextValue) ? value : nextValue;
};
